import BankIcon from '@/app/icons/bank.svg';
import AdminIcon from '@/app/icons/admin-services.svg';
import LegalIcon from '@/app/icons/legal.svg';
import TranslationIcon from '@/app/icons/translate.svg';
import FileDeleteIcon from '@/app/icons/file-delete.svg';
import PaidIcon from '@/app/icons/paid.svg';


export const servicesData = [
    {
        "name": "Bank Account Opening",
        "link": "/services/bank-account-opening",
        "icon": BankIcon,
    },
    {
        "name": "Administrative Services",
        "link": "/services/administrative-services",
        "icon": AdminIcon,
    },
    {
        "name": "Tax & Bookkeeping",
        "link": "/services/accounting",
        "icon": PaidIcon,
    },
    {
        "name": "Legal and Compliance Services",
        "link": "/services/legal",
        "icon": LegalIcon,
    },
    {
        "name": "Translation and Attestation Services",
        "link": "/services/translation",
        "icon": TranslationIcon,
    },
    {
        "name": "Company Liquidation Services",
        "link": "/services/liquidation",
        "icon": FileDeleteIcon,
    },
];